export default "__VITE_ASSET__C1nQWp_d__"